import { InscriptionService } from '../../../services/inscription.service';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from "ng2-toastr";
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { Http, Headers } from '@angular/http';
import { AuthHttp, JwtHelper } from 'angular2-jwt';
import 'rxjs/add/operator/map';
import { AuthenticationService } from '../../../services/authentication.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { EbUser } from '../../../classes/user';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../../shared/modal/modal.service';
import { Statique } from '../../../utils/statique';



@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['../account.component.css']
})
export class LoginComponent implements OnInit {

	model: any = {};
	accessToken: string;
	jwtHelper: JwtHelper = new JwtHelper();
	error = '';
	successMessage = "";
	newUser: EbUser;
	Statique = Statique;
	constructor(private router: Router, public http: Http, private authHttp: AuthHttp, private authenticationService: AuthenticationService, private inscriptionService: InscriptionService, private activatedRoute: ActivatedRoute,
		protected vcr?: ViewContainerRef, protected toastr?: ToastsManager, protected userService?: UserService, private translate?: TranslateService, protected modalService?: ModalService, ) {
		this.toastr.setRootViewContainerRef(vcr);
	}

	/*  getPersons() {
		 //return this.authHttp.get("/api/persons")
		 return this.authHttp.get("/api/ebCompagnies")
			 .map(res => {
				 return res.text();
			 });
	 } */


	ngOnInit() {

		this.authenticationService.logout();
		this.newUser = new EbUser();
		Statique.hideSideBar=true;


		let codeActivation = this.activatedRoute.snapshot.queryParams["codeActivation"];
		if (codeActivation) {
			let $this = this;
			this.error = null;
			this.userService.activationCompte(codeActivation).subscribe(
				result => {
					if (result) {
						// this.userService.login(result);
						//this.navigateAfterSuccess();
						//this.userService.notifyOther(true);
						// this.toastr.success(
						//   "Bienvenue sur My Tower. Votre compte est desormais actif. Vous pouvez dès à present vous connecter",
						//   "Succès"
						// );
						console.log("eeeeeeeeeeeeeeerrrrrrrrrrrrrrrrrrrrrrrrrr")
						this.successMessage = null;
						this.translate
							.get("INSCRIPTION.MY_TOWER_ACTIVATION_MESSAGE")
							.subscribe((res: string) => {
								this.successMessage = res;
							});
						this.modalService.information(
							"Information",
							this.successMessage,
							function () {
								// $this.router.navigate(['login']);
								window.location.href = window.location.origin + "/login";
							}
						);
					} else {
						this.error = "Une erreur sest produite sur le serveur";
					}
				},
				error => {
					this.error = "Une erreur sest produite sur le serveur";
				}
			);
		}
	}

	doLogin(e) {
		e.preventDefault();
		this.authenticationService.login(this.model.username, this.model.password)
			.subscribe(
			result => {

				if (result) {
					// redirect to home page
					this.authenticationService.notifySideBarInitUser();
					// this.router.navigate(['home']);
          window.location.href = window.location.origin + "/app/pricing/dashboard";

				} else {
					console.log('Email ou mot de passe incorrect');
					this.error = 'Email ou mot de passe incorrect';
				}
			},
			error => {
				console.log('Email ou mot de passe incorrect');
				this.error = 'Email ou mot de passe incorrect'
			}
			);
	}
	ngOnDestroy() {
		Statique.hideSideBar=false;
	}
}



// WEBPACK FOOTER //
// ./src/app/component/account/login/login.component.ts